import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {HateoasComposeItem} from '../utils/hateoas/hateoas-compose';
import {ParentBaseApiService} from './parent-base-api-service';
import {AbstractResource} from '../domain/abstract-resource';
import {HateoasResolver} from "../utils/hateoas/hateoas-resolver";
import {Subject} from "rxjs/Subject";

export abstract class BaseHateoasApiService<T, R extends AbstractResource<T>> extends ParentBaseApiService<T, R> {

    public findById(id: any, fetch: Map<string, HateoasComposeItem> = new Map<string, HateoasComposeItem>(), properties: any = null): Observable<T> {

        const response = new Subject<T>();

        const findById: Observable<T | R> = super.findById(id, properties);

        let findByIdAlive: boolean = true;
        findById.takeWhile(() => findByIdAlive)
            .subscribe((data: R) => {

                const resolver: HateoasResolver = new HateoasResolver(this.http);
                resolver.resolve(data, fetch)
                    .filter(d => d)
                    .takeWhile(() => findByIdAlive)
                    .subscribe((resolved: T) => {
                    response.next(resolved);
                    findByIdAlive = false;
                });

            });

        return response;
    }

    public findAll(fetch: Map<string, HateoasComposeItem> = new Map<string, HateoasComposeItem>(), properties: any = null): Observable<T[]> | null {

        const response = new Subject<T[]>();

        const findAll: Observable<T[] | R[]> | null = super.findAll(properties);

        if (!findAll) {
            return null;
        }

        let findAllAlive: boolean = true;
        findAll.takeWhile(() => findAllAlive)
            .subscribe((data: R[]) => {

                const resolver: HateoasResolver = new HateoasResolver(this.http);
                resolver.resolveArray(data, fetch)
                    .filter(d => d)
                    .takeWhile(() => findAllAlive)
                    .subscribe((resolved: T[]) => {
                        response.next(resolved);
                        findAllAlive = false;
                    });

            });

        return response;
    }

}
